module.exports = __webpack_public_path__ + "img/person-1.7c6c0472.png";